import { render, staticRenderFns } from "./eventStatistics.vue?vue&type=template&id=2551c74a&scoped=true&"
import script from "./eventStatistics.vue?vue&type=script&lang=js&"
export * from "./eventStatistics.vue?vue&type=script&lang=js&"
import style0 from "./eventStatistics.vue?vue&type=style&index=0&id=2551c74a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551c74a",
  null
  
)

export default component.exports